import React, { Component } from 'react'
import { Form as Formiker, Field, Formik } from 'formik';
import { Grid, Header, Icon, Button, Dropdown, input, Input, Loader } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import PdfAxios from "../axiosComponent/downloadpdf";
import FileCreatAxios from "../axiosComponent/fileupload"
import DeleteDocumentAxios from "../axiosComponent/deletedocument";
import UpdateAxios from "../axiosComponent/update";
import moment from 'moment';
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
  createShipmentDispatcher,
} from "../../redux/actions/shipmentAction";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import ModalDocumentDelete from "./documentDeleteModal";

 class Documentsupl extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          shipmentDetail: null,
          deleteDoc: false,
          docId: "",
          orders: [],
          blList: [],
          newDetails: null,
          bldocuments: [],
          iscanceled: false,
          shipmentEditMode: false,
          files: [],
          current_order: null,
          current_bl: null,
          show_current_bl : null,
          updateDoc: "",
          mystyle: {
            display: "table-cell",
            opacity: "1",
            verticalalign: "middle"
          }
        };
      }

     componentDidMount() {
       console.log('check order');
            ReadAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${this.props.order}/bl/list`,
            }).then((res) => {
              let tempArray = [];
              let info = res.data.data;
              tempArray = info.split(',');
              let bLOptions = tempArray.map((item, index) => {
                return {
                  key: index,
                  value: item,
                  text: item,
                  raw: { item },
                };
              });
              let temp = bLOptions;
              this.setState({
                blList : bLOptions,
                current_bl : bLOptions[0].key,
                show_current_bl: bLOptions[bLOptions[0].key].value
              })
              // if (this.state.blList.lenght > 0) {
                this.setState({
                  show_current_bl: this.state.blList[this.state.current_bl].value
                })
                ReadAxios({
                  completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${this.state.blList[this.state.current_bl].value}/documents`,
                }).then((res) => {
                  this.setState({
                    bldocuments: res.data.data
                  })
                })
                .catch((err) => {
                  console.log(err);
                });
              // }
            })
            .catch((err) => {
              console.log(err);
            });
      }

      getDocType = (type) => {
        if (this.state.bldocuments && this.state.bldocuments.length > 0) {
          for (const docType of this.state.bldocuments) {
            var docT = docType.doc_type
            var shipDocId = docType.filename
            if (type == docT) {
              return type == docT
            }
          }
        }
      }
    
      getfileName = (type) => {
        if (this.state.bldocuments && this.state.bldocuments.length > 0) {
          for (const docType of this.state.bldocuments) {
            var docT = docType.doc_type
            var shipFileNeame = docType.filename
            if (type == docT) {
              return shipFileNeame
            }
            // return shipDocId
          }
        }
      }
      getDocId = (type) => {
        if (this.state.bldocuments && this.state.bldocuments.length > 0) {
          for (const docType of this.state.bldocuments) {
            var docT = docType.doc_type
            var shipDocId = docType.shipment_doc_id
            if (type == docT) {
              return shipDocId
            }
            // return shipDocId
          }
        }
      }
    
      getDocIdDownload = (type) => {
        if (this.state.bldocuments && this.state.bldocuments.length > 0) {
          for (const docType of this.state.bldocuments) {
            var docT = docType.doc_type
            var shipDocId = docType.shipment_doc_id
            if (type == docT) {
              return shipDocId
            }
            // return shipDocId
          }
        }
      }

      downloadFile = (id) => {
        PdfAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${this.state.show_current_bl}/documents/${id}/download`,
        })
          .then((res) => {
            // let link = res.data;
            // link.setAttribute(link)
          })
          .catch((err) => {
            console.log(err);
          });
      }
    
      deleteDocument = (id) => {
        this.setState({
          deleteDoc: true,
          docId: id
        })
        // DeleteDocumentAxios({
        //   completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${this.state.show_current_bl}/documents/${id}`,
        // })
        //   .then((res) => {
        //     // let link = res.data;
        //     // link.setAttribute(link)
        //     this.props.success({
        //       type: "success",
        //       messageHeader: "Success",
        //       messageBody: res.message,
        //     });
        //     window.location.reload();
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
      }

      handleCancel = () => {
        this.setState({
          deleteDoc: false,
        })
      }

      setCurrentBLToShow = (data) => {
        console.log('data bl', data);
        this.setState({
          current_bl: data.options.find((ele) => ele.value === data.value).key,
          show_current_bl: data.value
        });
        ReadAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${data.value}/documents`,
        }).then((res) => {
          this.setState({
            bldocuments: res.data.data
          })
        })
        .catch((err) => {
          console.log(err);
        });
      };
    
      uploadFile = (id) => {
        document.getElementById(id).click();
      }
    
      updateFile = (name, id, value) => {
        let values = { [name]: value }
        FileCreatAxios({
          url: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${this.state.show_current_bl}/documents/${id}`,
          payload: { ...values },
        })
          .then((res) => {
            this.props.success({
              type: "success",
              messageHeader: "Success",
              messageBody: "File Updated Successfully",
            });
            window.location.reload();
          })
          .catch((err) => {
            this.props.error({
              type: "error",
              messageHeader: "Error",
              messageBody: err.response.data.error,
            });
            window.location.reload();
          });
      }

    render() {
      const { blList, show_current_bl, current_bl, bldocuments, deleteDoc } = this.state;
    const { t } = this.props;
        return (
            <div className="pad w3-white">
                <Formik
                  initialValues={{
                    mother_invoice: '',
                    original_bl: '',
                    proof_of_id: '',
                    inv_invoice: '',
                    exoneration: '',
                    packing_list: '',
                    failure_extract: '',
                    coa_certificate_of_analysis: '',
                    bd_shipment_database: '',
                    excel_request_for_collection: '',
                    di: '',
                    fispq_and_fe: '',
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    console.log(values);
                    // let shipmentId = this.props.location.search.split("=")[1];
                    setTimeout(() => {
                      FileCreatAxios({
                        completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/bl/${show_current_bl}/documents`,
                        payload: values,
                      })
                        .then((res) => {
                          if (res.status == 201) {
                            window.location.reload();
                          }
                          this.props.success({
                            type: "success",
                            messageHeader: "Success",
                            messageBody: res.message,
                          });
                        })
                        .catch((err) => {
                          this.props.error({
                            type: "error",
                            messageHeader: "Error",
                            messageBody: err.response.data.message,
                          });
                        });
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values, errors, touched, isSubmitting, setFieldValue }) => {
                    return (
                      <Formiker>
                        <Grid columns={4} className="ml-2">
                          <Grid.Row style={{ borderBottomColor: 'gray' }}>
                            <Grid.Column width={4} style={{ textAlign: 'left', width: '48.5%!important' }}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document_upload") || "Document Upload"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={6} floated="left">
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="blue"
                              >
                                {show_current_bl ? (
                                  <Dropdown
                                  defaultValue={show_current_bl}
                                  options={blList}
                                  name="current_bl_index"
                                  onChange={(name, data) => {
                                    this.setCurrentBLToShow(data);
                                  }}
                                />
                                )
                                 : (null)}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4} style={{ textAlign: 'right' }}>
                            {this.props.auth.role == "Quality Control" ? (
                                null
                              ) : (
                              <Button type="submitv " size="mini" disabled={isSubmitting}>
                                {isSubmitting ? (<Icon name="spinner" />) : (<>{t("submit_btn") || "Submit"}</>)}
                                
                              </Button>
                              )}
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.mother_invoice") || "Mother Invoice"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("mother_invoice") ? (
                                        <>{this.getfileName("mother_invoice")}
                                        </>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="mother_invoice" name="mother_invoice" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("mother_invoice", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )}
                                          </>
                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="mother_invoice" name="mother_invoice" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("mother_invoice", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="mother_invoice1" name="mother_invoice" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("mother_invoice", event.currentTarget.files[0]);
                                    this.updateFile("mother_invoice", this.getDocId("mother_invoice"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("mother_invoice") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini"
                                          type="button"
                                          onClick={() => this.uploadFile(
                                            "mother_invoice1", this.getDocId("mother_invoice")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button size="mini"
                                          basic type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("mother_invoice")
                                          )}
                                          color="primary"
                                          icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                        {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                          <Button size="mini"
                                            basic type="button"
                                            onClick={() => this.deleteDocument(
                                              this.getDocId("mother_invoice")
                                            )}
                                            color="red"
                                            icon>
                                            <Icon name="trash" />
                                          </Button>
                                        ) : (
                                            null
                                          )}
                                    </>
                                  ) : (
                                      null
                                    )}</>
                                ) : (
                                  null
                                )}
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.original_bl") || "Original BL"}
                              </Header>
                            </Grid.Column>
                            {console.log("Status update", values)}
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("original_bl") ? (
                                        <>{this.getfileName("original_bl")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="original_bl" name="original_bl" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("original_bl", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>
                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="original_bl" name="original_bl" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("original_bl", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="original_bl" name="original_bl" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("original_bl", event.currentTarget.files[0]);
                                    this.updateFile("original_bl", this.getDocId("original_bl"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("original_bl") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "original_bl", this.getDocId("original_bl")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button
                                          size="mini"
                                          basic type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("original_bl")
                                          )}
                                          color="primary"
                                          icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                        {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                          <Button size="mini"
                                            basic type="button"
                                            onClick={() => this.deleteDocument(
                                              this.getDocId("original_bl")
                                            )}
                                            color="red"
                                            icon>
                                            <Icon name="trash" />
                                          </Button>
                                        ) : (
                                          null
                                        )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.proof_of_dI") || "Proof of DI"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("proof_of_id") ? (
                                        <>{this.getfileName("proof_of_id")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="proof_of_id" name="proof_of_id" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("proof_of_id", event.currentTarget.files[0])
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>
                                        )
                                      }
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="proof_of_id" name="proof_of_id" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("proof_of_id", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="proof_of_id" name="proof_of_id" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("proof_of_id", event.currentTarget.files[0]);
                                    this.updateFile("proof_of_id", this.getDocId("proof_of_id"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("proof_of_id") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "proof_of_id", this.getDocId("proof_of_id")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("proof_of_id")
                                          )}
                                          basic
                                          color="primary"
                                          icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                      <Button size="mini"
                                        basic type="button"
                                        onClick={() => this.deleteDocument(
                                          this.getDocId("proof_of_id")
                                        )}
                                        color="red"
                                        icon>
                                        <Icon name="trash" />
                                      </Button>
                                      ) : (
                                      null
                                      )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.INV_invoice") || "INV - Invoice"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("inv_invoice") ? (
                                        <>{this.getfileName("inv_invoice")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="inv_invoice" name="inv_invoice" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("inv_invoice", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="inv_invoice" name="inv_invoice" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("inv_invoice", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="inv_invoice" name="inv_invoice" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("inv_invoice", event.currentTarget.files[0]);
                                    this.updateFile("inv_invoice", this.getDocId("inv_invoice"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("inv_invoice") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "inv_invoice", this.getDocId("inv_invoice")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button size="mini" basic type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("inv_invoice")
                                          )}
                                          color="primary" icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                        {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                        <Button size="mini"
                                          basic type="button"
                                          onClick={() => this.deleteDocument(
                                            this.getDocId("inv_invoice")
                                          )}
                                          color="red"
                                          icon>
                                          <Icon name="trash" />
                                        </Button>
                                        ) : (
                                        null
                                        )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.exoneration") || "Exoneration"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("exoneration") ? (
                                        <>{this.getfileName("exoneration")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="exoneration" name="exoneration" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("exoneration", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="exoneration" name="exoneration" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("exoneration", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="exoneration" name="exoneration" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("exoneration", event.currentTarget.files[0]);
                                    this.updateFile("exoneration", this.getDocId("exoneration"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("exoneration") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "exoneration", this.getDocId("exoneration")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button size="mini"
                                          type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("exoneration")
                                          )}
                                          basic color="primary" icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                        <Button size="mini"
                                          basic type="button"
                                          onClick={() => this.deleteDocument(
                                            this.getDocId("exoneration")
                                          )}
                                          color="red"
                                          icon>
                                          <Icon name="trash" />
                                        </Button>
                                        ) : (
                                        null
                                        )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.packing_list") || "Packing List"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("packing_list") ? (
                                        <>{this.getfileName("packing_list")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="packing_list" name="packing_list" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("packing_list", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}</>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="packing_list" name="packing_list" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("packing_list", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="packing_list" name="packing_list" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("packing_list", event.currentTarget.files[0]);
                                    this.updateFile("packing_list", this.getDocId("packing_list"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("packing_list") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "packing_list", this.getDocId("packing_list")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button size="mini"
                                          type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("packing_list")
                                          )}
                                          basic color="primary" icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                        {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                          <Button size="mini"
                                            basic type="button"
                                            onClick={() => this.deleteDocument(
                                              this.getDocId("packing_list")
                                            )}
                                            color="red"
                                            icon>
                                            <Icon name="trash" />
                                          </Button>
                                          ) : (
                                          null
                                          )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.failure_extract") || "Failure Extract"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("failure_extract") ? (
                                        <>{this.getfileName("failure_extract")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="failure_extract" name="failure_extract" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("failure_extract", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="failure_extract" name="failure_extract" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("failure_extract", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="failure_extract" name="failure_extract" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("failure_extract", event.currentTarget.files[0]);
                                    this.updateFile("failure_extract", this.getDocId("failure_extract"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("failure_extract") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "failure_extract", this.getDocId("failure_extract")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button size="mini"
                                          type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("failure_extract")
                                          )}
                                          basic color="primary" icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                        {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                          <Button size="mini"
                                            basic type="button"
                                            onClick={() => this.deleteDocument(
                                              this.getDocId("failure_extract")
                                            )}
                                            color="red"
                                            icon>
                                            <Icon name="trash" />
                                          </Button>
                                          ) : (
                                          null
                                          )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.coa") || "COA - (Certificate of Analysis)"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {/* {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("coa_certificate_of_analysis") ? (
                                        <>{this.getfileName("coa_certificate_of_analysis")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="coa_certificate_of_analysis" name="coa_certificate_of_analysis" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("coa_certificate_of_analysis", event.currentTarget.files);
                                                }} multiple/>
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="coa_certificate_of_analysis" name="coa_certificate_of_analysis" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("coa_certificate_of_analysis", event.currentTarget.files);
                                          }} multiple/>
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                <input id="coa_certificate_of_analysis" name="coa_certificate_of_analysis" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("coa_certificate_of_analysis", event.currentTarget.files[0]);
                                    this.updateFile("coa_certificate_of_analysis", this.getDocId("coa_certificate_of_analysis"), event.currentTarget.files[0])
                                  }} multiple/> */}
                                  {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("coa_certificate_of_analysis") ? (
                                        <>
                                          {bldocuments.filter(fispqFileName => fispqFileName.doc_type == "coa_certificate_of_analysis")
                                            .map(fispqFileName => (
                                              <>
                                                <span>
                                                  {fispqFileName.filename}&nbsp;
                                                </span>

                                                {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                                  <Button
                                                    size="mini" type="button"
                                                    className="w3-small pt-2 mb-1"
                                                    onClick={() => this.uploadFile(
                                                      "coa_certificate_of_analysis", fispqFileName.shipment_doc_id
                                                    )}
                                                    basic color="green"
                                                    icon
                                                  >
                                                    <Icon name="upload" />
                                                  </Button>
                                                ) : (
                                                    null
                                                  )}

                                                {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                                  <Button size="mini"
                                                    type="button"
                                                    className="w3-small pt-2 mb-1"
                                                    onClick={() => this.downloadFile(
                                                      fispqFileName.shipment_doc_id
                                                    )}
                                                    basic color="primary" icon>
                                                    <Icon name="download" />
                                                  </Button>
                                                ) : (
                                                    null
                                                  )}

                                                {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                                  <Button size="mini"
                                                    basic type="button"
                                                    className="w3-small pt-2 mb-1"
                                                    onClick={() => this.deleteDocument(
                                                      fispqFileName.shipment_doc_id
                                                    )}
                                                    color="red"
                                                    icon>
                                                    <Icon name="trash" />
                                                  </Button>
                                                  ) : (
                                                  null
                                                  )}
                                                <br />
                                              </>
                                            ))}
                                        </>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="coa_certificate_of_analysis" name="coa_certificate_of_analysis" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("coa_certificate_of_analysis", event.currentTarget.files);
                                                }} multiple />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="coa_certificate_of_analysis" name="coa_certificate_of_analysis" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("coa_certificate_of_analysis", event.currentTarget.files);
                                          }} multiple />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="coa_certificate_of_analysis" name="coa_certificate_of_analysis" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("coa_certificate_of_analysis", event.currentTarget.files);
                                    this.updateFile("coa_certificate_of_analysis", this.getDocId("coa_certificate_of_analysis"), event.currentTarget.files)
                                  }} multiple />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("coa_certificate_of_analysis") ? (
                                    <>
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.shipment_database") || "BD - Shipment Database"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("bd_shipment_database") ? (
                                        <>{this.getfileName("bd_shipment_database")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="bd_shipment_database" name="bd_shipment_database" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("bd_shipment_database", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="bd_shipment_database" name="bd_shipment_database" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("bd_shipment_database", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="bd_shipment_database" name="bd_shipment_database" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("bd_shipment_database", event.currentTarget.files[0]);
                                    this.updateFile("bd_shipment_database", this.getDocId("bd_shipment_database"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("bd_shipment_database") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "bd_shipment_database", this.getDocId("bd_shipment_database")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button size="mini"
                                          type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("bd_shipment_database")
                                          )}
                                          basic color="primary" icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                        {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                          <Button size="mini"
                                            basic type="button"
                                            onClick={() => this.deleteDocument(
                                              this.getDocId("bd_shipment_database")
                                            )}
                                            color="red"
                                            icon>
                                            <Icon name="trash" />
                                          </Button>
                                          ) : (
                                          null
                                          )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.excel_request_for_collection") || "Excel (Request for Collection)"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("excel_request_for_collection") ? (
                                        <>{this.getfileName("excel_request_for_collection")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="excel_request_for_collection" name="excel_request_for_collection" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("excel_request_for_collection", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="excel_request_for_collection" name="excel_request_for_collection" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("excel_request_for_collection", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="excel_request_for_collection" name="excel_request_for_collection" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("excel_request_for_collection", event.currentTarget.files[0]);
                                    this.updateFile("excel_request_for_collection", this.getDocId("excel_request_for_collection"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("excel_request_for_collection") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "excel_request_for_collection", this.getDocId("excel_request_for_collection")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button size="mini"
                                          type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("excel_request_for_collection")
                                          )}
                                          basic color="primary" icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                        <Button size="mini"
                                          basic type="button"
                                          onClick={() => this.deleteDocument(
                                            this.getDocId("excel_request_for_collection")
                                          )}
                                          color="red"
                                          icon>
                                          <Icon name="trash" />
                                        </Button>
                                        ) : (
                                        null
                                        )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.di") || "DI"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("di") ? (
                                        <>{this.getfileName("di")}</>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="di" name="di" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("di", event.currentTarget.files[0]);
                                                }} />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="di" name="di" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("di", event.currentTarget.files[0]);
                                          }} />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="di" name="di" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("di", event.currentTarget.files[0]);
                                    this.updateFile("di", this.getDocId("di"), event.currentTarget.files[0])
                                  }} />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("di") ? (

                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                        <Button
                                          size="mini" type="button"
                                          onClick={() => this.uploadFile(
                                            "di", this.getDocId("di")
                                          )}
                                          basic color="green"
                                          icon
                                        >
                                          <Icon name="upload" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                        <Button size="mini"
                                          type="button"
                                          onClick={() => this.downloadFile(
                                            this.getDocIdDownload("di")
                                          )}
                                          basic color="primary" icon>
                                          <Icon name="download" />
                                        </Button>
                                      ) : (
                                          null
                                        )}

                                      {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                        <Button size="mini"
                                          basic type="button"
                                          onClick={() => this.deleteDocument(
                                            this.getDocId("di")
                                          )}
                                          color="red"
                                          icon>
                                          <Icon name="trash" />
                                        </Button>
                                        ) : (
                                        null
                                        )}
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                style={{ fontSize: '14px' }}
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("document.FISPQ_and_FE") || "FISPQ and FE"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 p-2 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {bldocuments && bldocuments.length > 0 ?
                                  (
                                    <>
                                      {bldocuments && this.getDocType("fispq_and_fe") ? (
                                        <>
                                          {bldocuments.filter(fispqFileName => fispqFileName.doc_type == "fispq_and_fe")
                                            .map(fispqFileName => (
                                              <>
                                                <span>
                                                  {fispqFileName.filename}&nbsp;
                                                </span>

                                                {this.props.permissions.TA_DOCUMENTS.UPDATE == true ? (
                                                  <Button
                                                    size="mini" type="button"
                                                    className="w3-small pt-2 mb-1"
                                                    onClick={() => this.uploadFile(
                                                      "fispq_and_fe", fispqFileName.shipment_doc_id
                                                    )}
                                                    basic color="green"
                                                    icon
                                                  >
                                                    <Icon name="upload" />
                                                  </Button>
                                                ) : (
                                                    null
                                                  )}

                                                {this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
                                                  <Button size="mini"
                                                    type="button"
                                                    className="w3-small pt-2 mb-1"
                                                    onClick={() => this.downloadFile(
                                                      fispqFileName.shipment_doc_id
                                                    )}
                                                    basic color="primary" icon>
                                                    <Icon name="download" />
                                                  </Button>
                                                ) : (
                                                    null
                                                  )}

                                              {this.props.permissions.TA_DOCUMENTS.DELETE == true ? (
                                                <Button size="mini"
                                                  basic type="button"
                                                  className="w3-small pt-2 mb-1"
                                                  onClick={() => this.deleteDocument(
                                                    fispqFileName.shipment_doc_id
                                                  )}
                                                  color="red"
                                                  icon>
                                                  <Icon name="trash" />
                                                </Button>
                                                ) : (
                                                null
                                                )}
                                                <br />
                                              </>
                                            ))}
                                        </>
                                      ) : (
                                          <>
                                            {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                              <input id="fispq_and_fe" name="fispq_and_fe" type="file" accept="application/pdf, application/vnd.ms-excel"
                                                onChange={(event) => {
                                                  setFieldValue("fispq_and_fe", event.currentTarget.files);
                                                }} multiple />
                                            ) : (
                                                "No File Uploaded"
                                              )} </>

                                        )}
                                    </>
                                  )
                                  :
                                  (
                                    <>
                                      {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                        <input id="fispq_and_fe" name="fispq_and_fe" type="file" accept="application/pdf, application/vnd.ms-excel"
                                          onChange={(event) => {
                                            setFieldValue("fispq_and_fe", event.currentTarget.files);
                                          }} multiple />
                                      ) : (
                                          "No File Uploaded"
                                        )}
                                    </>
                                  )}
                                  {this.props.permissions.TA_DOCUMENTS.CREATE == true ? (
                                <input id="fispq_and_fe" name="fispq_and_fe" type="file" style={{ display: 'none' }} accept="application/pdf, application/vnd.ms-excel"
                                  onChange={(event) => {
                                    setFieldValue("fispq_and_fe", event.currentTarget.files);
                                    this.updateFile("fispq_and_fe", this.getDocId("fispq_and_fe"), event.currentTarget.files)
                                  }} multiple />
                                  ) : (
                                    null
                                  )}
                              </Header>
                              {bldocuments && bldocuments.length > 0 ?
                                (
                                  <>{this.getDocType("fispq_and_fe") ? (
                                    <>
                                    </>
                                  ) : (
                                      ""
                                    )}</>
                                ) : (
                                  ""
                                )}
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Formiker>
                    );
                  }}
                </Formik>
                {this.state.deleteDoc && (
                <ModalDocumentDelete
                  open={this.state.deleteDoc}
                  id={this.state.docId}
                  success={this.props.success}
                  bl={this.state.show_current_bl}
                  handleCancel={this.handleCancel}
                  handleConfirm={this.handleConfirm}
                />
              )}
              </div>
              
        )
    }
}

const mapStateToProps = ({ permissions, auth }) => {
    return {
      permissions,
      auth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        success: (alert) => dispatch(successAlertDispatcher(alert)),
        error: (alert) => dispatch(errorAlertDispatcher(alert)),
        create: (shipment) => dispatch(createShipmentDispatcher(shipment, true))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("shipment_details")(Documentsupl));
